import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "../css/Services.css";

const messages = [
  "New Update on Course!‘Free TallyPrime Access for Tally Learners’",
  "Enroll now and get Certified by Tally!",
  "Live Training sessions are now available!",
  "Internship Opportunities for all learners!"
];

const Hero = () => {

  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);
      setTimeout(() => {
        setAnimate(false);
        setIndex((prevIndex) => (prevIndex + 1) % messages.length);
      }, 2000); // Wait 1s before switching text
    }, 2000); // Total 2s cycle (1s show, 1s scroll)

    return () => clearInterval(interval);
  }, []);

  return (
    <>
          <Helmet>
        <title>Shrikant Tally Institute | Learn Tally & Get Job Placement</title>
        <meta
          name="description"
          content="Become a certified Tally expert with Shrikant Tally Institute in Damoh. We offer professional accountant training with guaranteed placement opportunities. Enroll now!"
        />
        <meta
          name="keywords"
          content="Tally course, Tally training, accounting course, job placement, certified accountant, Damoh, Shrikant Tally Institute, TallyPrime, internship"
        />
        <meta name="author" content="Shrikant Tally Institute" />
        <meta property="og:title" content="Shrikant Tally Institute | Learn Tally & Get Job Placement" />
        <meta property="og:description" content="Become a certified Tally expert with Shrikant Tally Institute in Damoh. We offer professional accountant training with guaranteed placement opportunities. Enroll now!" />
        <meta property="og:url" content="https://shrikanttallyinstitute.com/" />
        {/* You can add more Open Graph meta tags as needed */}
      </Helmet>
    
    <div className="text-dark py-1 curve-container">
      <div className="container mt-4">
        <div className="row align-items-center">

          {/* Left Column - Text */}
          <div className="col-md-6 text-center text-md-start mb-4 mb-md-0 animate-left">
            <h1 className="display-5 fw-bold mb-2">Learn, Earn & Grow</h1>
            <p className="fw-semibold mb-1" style={{ color: '#4d3d6c', fontSize: '1.1rem' }}>Professional Accountant Training</p>
            <p className="fw-bold mb-3" style={{ color: '#90b732', fontSize: '1.05rem' }}>Become a Certified Tally Expert</p>

            <p className="text-muted mb-3" style={{ fontSize: '15px', lineHeight: 1.8 }}>
              Gain practical accounting skills with industry-focused Tally training and build a strong foundation for your career in finance and accounting.
            </p>

            <ul className="list-unstyled mb-4" style={{ fontSize: '14px' }}>
              {[
                'Hands-on training in Tally & GST',
                'Real-world accounting projects',
                'Certification support',
                'Interview preparation & career guidance',
                'Placement assistance for eligible candidates',
              ].map((item, i) => (
                <li key={i} className={`d-flex align-items-center gap-2 mb-2 animate-fadeup delay-${i + 1}`}>
                  <span style={{ color: '#90b732', fontWeight: 700, fontSize: 16 }}>✓</span>
                  <span style={{ color: '#444' }}>{item}</span>
                </li>
              ))}
            </ul>

            <p className="text-muted mb-4" style={{ fontSize: '13.5px', fontStyle: 'italic' }}>
              Start your journey towards a successful accounting career today.
            </p>

            <Link to="/register" className="btn btn-lg text-light fw-semibold animate-fadeup delay-5" style={{ background: '#90b732', transition: 'transform 0.2s, box-shadow 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 6px 18px rgba(144,183,50,0.4)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow=''; }}>
              Enroll Now
            </Link>
          </div>

          {/* Right Column - Video */}
<div className="col-md-6 text-center animate-right">
  <video 
    src={`${process.env.PUBLIC_URL}/1.mp4`} 
    autoPlay 
    muted 
    loop 
    playsInline 
    className="img-fluid rounded mb-3 shadow"
    style={{ maxWidth: '100%', height: 'auto', transition: 'transform 0.4s ease, box-shadow 0.4s ease' }}
    onMouseEnter={e => { e.currentTarget.style.transform='scale(1.02)'; e.currentTarget.style.boxShadow='0 12px 32px rgba(0,0,0,0.15)'; }}
    onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow=''; }}
  />
  <p className="fw-bold animate-fadeup delay-3" style={{ color: "#823470" }}>
    ISO 9001 : 2015 Certified
  </p>
</div>

        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center banner-container mx-auto mt-5 w-75 " style={{height:'90px'}} >
        <div className={`scrolling-text ${animate ? 'slide' : ''}`}>
          <img
            src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/ani.gif"
            height="90px"
            alt="GIF"
            className="me-4"
          />
          {messages[index]}
        </div>
        <div className="dot-row">
          {messages.map((_, i) => (
            <div
              key={i}
              className={`dot ${i === index ? 'active' : ''}`}
            />
          ))}
        </div>
      </div>
    </div>
    </>
  );
}

export default Hero;
